module.exports = __webpack_public_path__ + "static/media/main.513ad812.png";